import { useEffect, useState } from "react";
import PU_FORM from "./pu-form";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const PU_KYC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const token = location.hash.substring(1);

  const [userData, setUserData] = useState<{
    data: { customerId: string; isResident: string };
  }>({
    data: { customerId: "", isResident: "" },
  });

  useEffect(() => {
    axiosInstance
      .post(
        "api/customer/register/wb-card/residence",
        {},
        {
          headers: {
            "x-api-key": token || "",
          },
        }
      )
      .then((data) => {
        setUserData(data);
      })
      .catch((err) => {
        navigate(`/${i18n.language}/error`, {
          state: {
            title: t("error.title"),
            description: err?.response?.data?.DisplayText,
            errorBtn: "show",
          },
        });
      });
  }, [token]);

  return <PU_FORM userData={userData?.data} apiKey={token || ""} />;
};

export default PU_KYC;
